import API_BASE_URL from '../Config';

export const getTiposDocumento = async (token) => {
    const response = await fetch(`${API_BASE_URL}/tipos-documento`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de documento');
    return response.json();
};

export const getTiposDocumentoPaginadas = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/tipos-documento/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de documento paginados');
    return response.json();
};

export const getTipoDocumentoById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-documento/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el tipo de documento');
    return response.json();
};

export const createTipoDocumento = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/tipos-documento`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el tipo de documento');
    return response.json();
};

export const updateTipoDocumento = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/tipos-documento/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el tipo de documento');
    return response.json();
};

export const darDeBajaTipoDocumento = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-documento/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja el tipo de documento');
};

export const deleteTipoDocumento = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-documento/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar el tipo de documento');
};
